import { Dispatch } from 'react';
import { getAllAffirmations, getAllCategories, getAllReels, getAllReelsCategories } from '../api/api';
import { ActionInterface, setCategoryAndAffirmation, setReelsAndReelsCategories } from '../store/actions/actions';

/**
 * Gets all affirmations & categories, set to redux.
 * Gets reels affirmations & reels categories, set to redux.
 */
const getDataSetToRedux = async (dispatch: Dispatch<ActionInterface>) => {
    console.log("REQUESTED");
    const affirmations = await getAllAffirmations();
    const categories = await getAllCategories();

    const reels = await getAllReels();
    const reelsCategory = await getAllReelsCategories();

    if (affirmations.length === 0 || categories.length === 0) {
        console.log("Error in GET Affirmations!")
    }
    if (reels.length === 0 || reelsCategory.length === 0) {
        console.log("Error in GET Reels!")
    }

    dispatch(setCategoryAndAffirmation(affirmations, categories));

    dispatch(setReelsAndReelsCategories(reels, reelsCategory));
}
export {
    getDataSetToRedux,
}